! function(t) {
    "use strict";
    t(document).ready(function() {
        $(".frst-timeline-content").css("position","relative");
        var defaultAnimation=$(".frst-container").attr("data-animation-name");       
        function n(n, i) {
            n.each(function() {
                var n = t(this).data("animation") || defaultAnimation;
                t(this).find(".frst-timeline-content").addClass("is-hidden").removeClass("animated " + n), "" == t("#select-animation").val() && t(this).find(".frst-timeline-content").removeClass("is-hidden");
            })
        }

        function i(n, i) {
            n.each(function() {
                if (t("#select-animation").val()) t(this).offset().top <= t(window).scrollTop() + t(window).height() * i && t(this).find(".frst-timeline-content").hasClass("is-hidden") && t(this).find(".frst-timeline-content").removeClass("is-hidden").addClass("animated " + t("#select-animation").val() && t(this).removeClass("is-not-shown") );
                else {
                    var n = t(this).data("animation") || defaultAnimation;
                    n && t(this).offset().top <= t(window).scrollTop() + t(window).height() * i && t(this).find(".frst-timeline-content").hasClass("is-hidden") && t(this).find(".frst-timeline-content").removeClass("is-hidden").addClass("animated " + n) && t(this).removeClass("is-not-shown");
                }
            })
        }

        function e(n, i) {
            var e = 0;
            n.each(function() {
                var n = t(this).data("animation") || "defaultAnimation";
                if (n && t(window).scrollTop() + t(window).height() * i > t(this).offset().top && t(this).find(".frst-timeline-content").hasClass("is-hidden")) {
                    var a = t(this);
                    setTimeout(function() {
                        var fix = t("#select-animation").val() || defaultAnimation ;
                        a.find(".frst-timeline-content").removeClass("is-hidden").addClass("animated " + fix);
                        // console.log(a);
                        a.removeClass("is-not-shown");
                    }, e)
                }
                e += 200
            })
        }
        var a = t(".frst-timeline-block"),
            s = .8;
        n(a, s), e(a, s), t(window).on("scroll", function() {
            window.requestAnimationFrame ? window.requestAnimationFrame(function() {
                i(a, s)
            }) : setTimeout(function() {
                i(a, s)
            }, 100)
        }), t(document).on("click", ".switch-btn", function(n) {
            n.preventDefault(), t(".header-style-options").slideToggle()
        }), t(document).on("click", ".style-class-switch a", function(n) {
            n.preventDefault();
            var i = t(this).data("styleclass");
            t(".style-class-switch li").removeClass("active"), t(this).parent().addClass("active"), t(".frst-timeline").removeClass("frst-alternate frst-right-align frst-left-align"), t(".frst-timeline").addClass("frst-" + i), t(".frst-container").removeClass("content-alternate content-right-align content-left-align"), t(".frst-container").addClass("content-" + i)
        }), t(document).on("change", "#select-animation", function() {
            var i = this.value;
            n(a, s), window.requestAnimationFrame ? window.requestAnimationFrame(function() {
                e(a, s)
            }) : setTimeout(function() {
                e(a, s)
            }, 300), t(".frst-timeline-block").data("animation", i)
        }), t(".frst-date").length && t(".check-style").show(), t("#dateToggle").change(function() {
            t(".frst-timeline").toggleClass("frst-date-opposite", this.checked)
        }).change()
    })
}(jQuery);

/*
$(window).on("scroll", function() {
    $('.frst-timeline-style-storyline > .frst-timeline-block').each(function(){
        console.log($(this));
        // console.log('this offset: '+$(this).offset().top);
        // console.log('scrollTop: '+$(window).scrollTop());

        var theshold = 200;

//        if( ( $(this).offset().top - theshold ) < $(window).scrollTop() ){
//            console.log('show');
//            console.log($(this));
//            if( !$(this).hasClass('show-bg') ){
//                $(this).addClass('show-bg');
//            }
//        }else{
//            
//        }
    });
});
*/

$(document).ready(function() {
    // appear will be fired when "myEl" is 100 or less pixels
    // below browser viewport 


    $('.frst-timeline-style-storyline .frst-timeline-block').each(function(){


        $(this).scrolling({ offsetTop: -500 }); 
        $(this).on('scrollin', function(event, $all_elements) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            // we reach this point as soon as the 'selector' element becomes visibile inside the browser viewport.
            // $all_elements contains all the appeared elements.
            // console.log($all_elements);
            $('.frst-timeline-style-storyline .frst-timeline-block').removeClass('active-bg');
            $(this).addClass('active-bg');
            $(window).trigger('resize');
        });      
        $(this).on('scrollout', function(event, $all_elements) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            // we reach this point as soon as the 'selector' element goes outside the browser viewport.
            // $all_elements contains all the disappeared elements.
            // console.log($all_elements);
            $(this).removeClass('active-bg');
            $(window).trigger('resize');
        });  

    });



});
